<template>
  <div class="content-container">
    <!-- search component -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tên công ty/đại lý du lịch</div>
                <input
                  v-model="searchParams.name"
                  type="text"
                  placeholder=""
                  class="elInput"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã công ty/đại lý du lịch</div>
                <input
                  v-model="searchParams.code"
                  type="text"
                  placeholder=""
                  class="elInput"
                />
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nguồn</div>
                <el-select
                  v-model="searchParams.sourceId"
                  placeholder="Chọn nguồn khách"
                  filterable
                  no-match-text="Không có dữ liệu"
                  no-data-text="Không có dữ liệu"
                >
                  <el-option :value="null" label="Chọn" />
                  <el-option
                    v-for="(option, index) in customerSourceOptions"
                    :key="index"
                    :value="option.id"
                    :label="`${option.code} - ${option.desc}`"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <!-- Grid -->
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        dom-layout="scroll"
        row-selection="single"
        :auto-select-first-row="false"
        :auto-size-cell="true"
        :row-multi-select-with-click="true"
        @selectionChanged="onSelectionChanged"
      />
    </div>

    <!-- Pagination -->
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <!-- Btns -->
    <div class="button-containers">
      <button
        :disabled="selectedRows.length !== 1"
        type="button"
        class="btn primary small"
        @click="dialogDepositVisible = true"
      >
        Thêm nạp tiền
      </button>
      <button
        type="button"
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="dialogWalletDetailVisible = true"
      >
        Xem chi tiết
      </button>
    </div>

    <!-- Dialog -->
    <WalletDetailDialog
      v-model="dialogWalletDetailVisible"
      :agent-id="props.agentId"
      :agent-name="props.agentName"
    />

    <DepositMoneyDialog
      v-model="dialogDepositVisible"
      :agent-id="props.agentId"
      :agent-name="props.agentName"
      @refresh="onSearch"
    />
  </div>
</template>

<script>
import WalletDetailDialog from './components/WalletDetailDialog.vue'
import paginationMixin from '@/mixins/paginationMixin'

import { getAgentWalletList } from '@/api/accounting/agent-wallet'
import { getSourceListApi } from '@/api/common/source'
import { notifyError } from '@/utils/toast'
import { formatVND } from '@/utils/commonUtils'
import DepositMoneyDialog from './components/DepositMoneyDialog.vue'

export default {
  components: { WalletDetailDialog, DepositMoneyDialog },
  mixins: [paginationMixin],
  data() {
    return {
      searchParams: {
        code: null,
        name: null,
        sourceId: null
      },
      defaultSearchParams: {
        code: null,
        name: null,
        sourceId: null
      },

      customerSourceOptions: [],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 50,
          maxWidth: 50,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        { headerName: 'Mã công ty/đại lý', field: 'agent_code', width: 100 },
        { headerName: 'Tên công ty/đại lý', field: 'agent_name', width: 200 },
        { headerName: 'Nguồn', field: 'source_code', width: 100 },
        {
          headerName: 'Số dư',
          field: 'balance',
          valueGetter: params => formatVND(params.data.balance),
          cellClass: 'grid-cell-right',
          width: 100
        }
      ],
      rows: [],
      selectedRows: [],

      // dialog
      dialogDepositVisible: false,
      dialogWalletDetailVisible: false,

      // child props:
      props: {
        agentId: null,
        agentName: null
      }
    }
  },

  async mounted() {
    await this.fnGetCustomerSourceOptions()
    await this.fnGetAgentWalletList()
  },

  methods: {
    // handle event
    onSearch() {
      this.pageParams.pageNum = 1
      this.fnGetAgentWalletList()
    },
    onReset() {
      this.searchParams = Object.assign({}, this.defaultSearchParams)
      this.onSearch()
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetAgentWalletList()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetAgentWalletList()
    },

    onSelectionChanged(value) {
      this.selectedRows = value
      this.props.agentId = value[0]?.agent_id
      this.props.agentName = value[0]?.agent_name
    },

    // handle api call
    async fnGetAgentWalletList() {
      const query = {
        ...this.searchParams,
        currentPage: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize
      }
      let res
      try {
        res = await getAgentWalletList(query)
        this.rows = res.data
        this.pageParams.totalPage = Math.ceil(
          res.total / this.pageParams.pageSize
        )
      } catch (error) {
        const message = error.response?.data?.message
        notifyError(message)
      }
    },
    async fnGetCustomerSourceOptions() {
      const data = await getSourceListApi({
        isActive: 1
      })
      this.customerSourceOptions = data.data || []
    }
  }
}
</script>
